import {
  handleWithErrorMessage,
  handleWithGlobalMessage
} from "@/services/utils";
import api from "@/services/modules/organisations/organisation-approval-chain-templates";
import {
  SET_IS_FETCHING_APPROVAL_CHAINS,
  SET_APPROVAL_CHAIN_TEMPLATES,
  SET_CURRENT_APPROVAL_CHAIN,
  SET_IS_FETCHING_CURRENT_APPROVAL_CHAIN
} from "@/store/modules/organisations/organisation-approval-chain-templates/mutations";

export const FETCH_APPROVAL_CHAIN_TEMPLATES = "FETCH_APPROVAL_CHAIN_TEMPLATES";
export const CREATE_APPROVAL_CHAIN_TEMPLATE = "CREATE_APPROVAL_CHAIN_TEMPLATE";
export const UPDATE_APPROVAL_CHAIN_TEMPLATE = "UPDATE_APPROVAL_CHAIN_TEMPLATE";
export const FETCH_APPROVAL_CHAIN_TEMPLATE = "FETCH_APPROVAL_CHAIN_TEMPLATE";

const actions = {
  async [FETCH_APPROVAL_CHAIN_TEMPLATES]({ commit, dispatch }, params) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getAll(params),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_APPROVAL_CHAINS, isLoading),
      setDataFunction: ({ data }) => commit(SET_APPROVAL_CHAIN_TEMPLATES, data)
    });
  },
  async [FETCH_APPROVAL_CHAIN_TEMPLATE]({ commit, dispatch }, id) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getApprovalChain(id),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_CURRENT_APPROVAL_CHAIN, isLoading),
      setDataFunction: ({ data }) => commit(SET_CURRENT_APPROVAL_CHAIN, data)
    });
  },
  async [CREATE_APPROVAL_CHAIN_TEMPLATE]({ commit, dispatch }, data) {
    await handleWithGlobalMessage(() => api(commit).add(data), dispatch);
    dispatch(FETCH_APPROVAL_CHAIN_TEMPLATES, {});
  },
  async [UPDATE_APPROVAL_CHAIN_TEMPLATE]({ commit, dispatch }, data) {
    await handleWithGlobalMessage(() => api(commit).edit(data), dispatch);
    dispatch(FETCH_APPROVAL_CHAIN_TEMPLATES, {});
  }
};

export default actions;
